// Module
var code = `<div class="investing_checkBox_container {{.styleClassed}}" style="{{>visibility}}" as-tooltip="tooltip"
        on-click="@this.private_CheckBoxClick(this)" on-mousedown="@this.onMouseDown(event)">

    <input type="button" class="investing_checkBox_input_button" ischecked="{{.checked?'1':'0'}}"
           checkBoxCheckedState="{{.checkBoxCheckedState}}" as-tooltip="tooltip" {{>visualparameters}} />

    {{#if .text}}
    <div class="investing_checkBox_label" {{^.width}}style="white-space: nowrap;" {{/}} {{^.enabled}}disabled="" {{/}}>{{.text}}</div>
    {{/if}}
</div>`;
// Exports
export default code;